var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: 12,
    transform: "translate(-1776.000000, -940.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-copy-2",
    transform: "translate(1778.000000, 942.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-copy",
    transform: "translate(11.000000, 11.000000) scale(-1, 1) translate(-11.000000, -11.000000) "
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 11,
    x2: 0,
    y2: 11,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "11 22 0 11 11 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.8caa8cf2ec45078db3db6498f5f95d9c.svg";
export { ForwardRef as ReactComponent };